import { atom as p, computed as h, map as f } from "nanostores";
import { copilotTools as y, copilotInstructions as b, copilotContext as T, uniqueId as m } from "./global-state.js";
const g = {
  idle: ["initializing", "destroying"],
  initializing: ["ready", "error"],
  ready: ["sending", "destroying"],
  sending: ["receiving"],
  receiving: ["ready"],
  destroying: ["destroyed", "error"],
  error: ["initializing", "destroying"],
  destroyed: ["destroyed"]
  // Can only transition to itself (terminal state)
};
function v(t, s) {
  if (!g[t])
    throw new Error(`Unknown status: ${t}`);
  if (g[t].includes(s))
    return s;
  throw new Error(`Invalid status transition: ${t} -> ${s}`);
}
class A {
  constructor(s = {}) {
    this.config = {
      includeGlobalContext: !0,
      includeGlobalTools: !0,
      includeGlobalInstructions: !0
    }, this.destoryIsScheduled = !1, this.__status = p("idle"), this.__messages = p([]), this.__statefulMessages = h(this.__messages, x), this.__serverSideTools = p([]), this.__sessionInstructions = f({}), this.__sessionTools = f({}), this.__sessionContext = f({}), this.__availableTools = h(
      [y, this.__sessionTools, this.__serverSideTools],
      (o, i, r) => [...this.config.includeGlobalTools === !0 ? Object.values(o) : [], ...Object.values(i), ...r].filter((e) => e != null)
    ), this.__tools = h([y, this.__sessionTools], (o, i) => ({
      ...this.config.includeGlobalTools === !0 ? o : {},
      ...i
    })), this.__instructions = h(
      [b, this.__sessionInstructions],
      (o, i) => ({
        ...this.config.includeGlobalInstructions === !0 ? o : {},
        ...i
      })
    ), this.__context = h([T, this.__sessionContext], (o, i) => ({
      ...this.config.includeGlobalContext === !0 ? o : {},
      ...i
    })), this.config = {
      ...this.config,
      ...s
    };
  }
  /**
   * The current status of the Copilot session.
   */
  get status() {
    return this.__status.get();
  }
  /**
   * If the session is being destroyed.
   */
  get isDestroying() {
    return this.status === "destroying" || this.destoryIsScheduled;
  }
  get isDestroyed() {
    return this.status === "destroyed";
  }
  /**
   * Sets the status of the Copilot session.
   */
  setStatus(s) {
    this.__status.set(v(this.status, s)), this.destoryIsScheduled && g[this.status].includes("destroying") && (this.destoryIsScheduled = !1, this.destroy());
  }
  /**
   * adds an instruction just for this session
   */
  addInstruction(s) {
    const o = m();
    return this.__sessionInstructions.setKey(o, s), () => {
      this.__sessionInstructions.setKey(o, void 0);
    };
  }
  /**
   * Adds a tool just for this session
   */
  addTool(s) {
    return this.__sessionTools.setKey(s.name, s), () => {
      this.__sessionTools.setKey(s.name, void 0);
    };
  }
  /**
   * Adds a context just for this session
   */
  addContext(s) {
    const o = m();
    return this.__sessionContext.setKey(o, s), () => {
      this.__sessionContext.setKey(o, void 0);
    };
  }
  /**
   * Initializes a new session, either from an existing session id,
   * or by creating a new one
   */
  async initialize(s) {
    if (this.status !== "idle" && this.status !== "error")
      return this.id;
    this.setStatus("initializing");
    try {
      const o = window.__hydra_copilot__?.startSession;
      if (o == null)
        throw new Error("Copilot session not configured. Please set the Copilot configuration first.");
      if (s == null) {
        const i = await o();
        if (i.id == null)
          throw new Error("Failed to start session, no session ID returned");
        this.id = i.id, this.__serverSideTools.set(i.tools ?? []);
      } else
        this.id = s, this.__messages.set(await this.loadRemoteMessages());
      return this.setStatus("ready"), this.id;
    } catch (o) {
      throw this.setStatus("error"), o;
    }
  }
  /**
   * Schedules a session to be destroyed.
   *
   * This will destroy the session as soon as it is safe to do so.
   */
  scheduleDestroy() {
    g[this.status].includes("destroying") ? this.destroy() : this.destoryIsScheduled = !0;
  }
  /**
   * Destroys the current session, clearing all messages and state.
   */
  async destroy() {
    this.setStatus("destroying");
    try {
      const s = window.__hydra_copilot__?.destroySession;
      if (s == null)
        throw new Error("Copilot session not configured. Please set the Copilot configuration first.");
      this.id != null && await s(this.id), this.__messages.set([]), this.id = void 0, this.__sessionInstructions.set({}), this.__sessionTools.set({}), this.__sessionContext.set({}), this.__serverSideTools.set([]), this.setStatus("destroyed");
    } catch (s) {
      throw this.setStatus("error"), s;
    }
  }
  /**
   * Sends a new message to the session
   */
  async sendMessage(s) {
    const o = window.__hydra_copilot__?.sendStreamingMessage;
    if (o == null)
      throw new Error("Copilot session not configured. Please set the Copilot configuration first.");
    if (this.status === "idle" && await this.initialize(), this.status !== "ready")
      throw new Error(`Cannot send message while session is in "${this.status}" state.`);
    try {
      this.setStatus("sending");
      let i = [
        { role: "user", type: "text", text: s, timestamp: Date.now() }
      ];
      for (; i.length > 0; ) {
        this.__messages.set([...this.__messages.get(), ...i]);
        const r = [], l = [], e = (u) => {
          if (this.__messages.set([...this.__messages.get(), u]), this.status === "sending" && this.setStatus("receiving"), u.role === "model" && u.type == "tool_call")
            for (const a of u.tool_calls) {
              const _ = this.__tools.get()[a.name];
              _ != null && r.push(
                (async () => {
                  try {
                    const c = await _.handler(a.args);
                    l.push({
                      tool_call_id: a.id,
                      name: a.name,
                      followUp: _.followUp ?? !0,
                      response: { result: c, error: null }
                    });
                  } catch (c) {
                    l.push({
                      tool_call_id: a.id,
                      name: a.name,
                      followUp: _.followUp ?? !0,
                      response: {
                        result: null,
                        error: `Error calling tool ${a.name}: ${c instanceof Error ? c.message : String(c)}`
                      }
                    });
                  }
                })()
              );
            }
        }, n = {
          id: this.id,
          messages: i,
          tools: I(this.__tools.get()),
          instructions: C(this.__instructions.get()),
          context: M(this.__context.get()),
          onMessage: e
        };
        await o(n), await Promise.all(r);
        const d = [
          {
            role: "user",
            type: "tool_response",
            tool_responses: l,
            timestamp: Date.now()
          }
        ];
        l.some((u) => u.followUp) ? i = d : (i = [], this.__messages.set([...this.__messages.get(), ...d]));
      }
      this.setStatus("ready");
    } catch (i) {
      throw this.status === "sending" && this.setStatus("receiving"), this.setStatus("ready"), i;
    }
  }
  /**
   * Loads the messages of the session
   */
  async loadRemoteMessages() {
    const s = window.__hydra_copilot__?.getSessionMessages;
    if (s == null)
      throw new Error("Copilot session not configured. Please set the Copilot configuration first.");
    if (this.id == null)
      throw new Error("Session not started");
    return await s(this.id);
  }
}
function w(t) {
  return typeof t == "string" ? t : typeof t == "number" || typeof t == "boolean" ? String(t) : Array.isArray(t) || typeof t == "object" ? JSON.stringify(t) : String(t);
}
function x(t) {
  const s = [];
  let o = [];
  const i = {}, r = t.filter(
    (e) => {
      if (e.role === "user" && e.type === "tool_response") {
        for (const n of e.tool_responses)
          n.tool_call_id != null && (i[n.tool_call_id] = n);
        return !1;
      }
      return e.type === "text" || e.type === "tool_call";
    }
  );
  function l() {
    if (o.length === 0)
      return;
    const e = o.map((n) => n.text).join("");
    s.push({
      role: "model",
      type: "text",
      text: e,
      timestamp: o[0].timestamp
    }), o = [];
  }
  for (const e of r)
    e.role === "model" && e.type === "text" ? o.push(e) : e.role === "user" && e.type === "text" ? (l(), s.push(e)) : e.role === "model" && e.type === "tool_call" ? (l(), s.push({
      role: "model",
      type: "tool_call",
      tool_calls: e.tool_calls.map((n) => {
        const d = i[n.id];
        return d == null ? {
          ...n,
          status: "executing"
        } : {
          ...n,
          status: d.response.error == null ? "success" : "error"
        };
      }),
      timestamp: e.timestamp
    })) : console.error("Unknown message type", e);
  return l(), s;
}
function I(t) {
  return Object.values(t).filter((s) => s !== void 0).map((s) => ({
    name: s.name,
    description: s.description,
    request_json_schema: s.requestSchema,
    json_response_schema: s.responseSchema,
    follow_up: s.followUp ?? !0
  }));
}
function C(t) {
  return Array.isArray(t) ? t.map((s) => S(s.instruction).trim()) : Object.values(t).filter((s) => s !== void 0).map((s) => S(s.instruction).trim());
}
function M(t) {
  return Array.isArray(t) ? t.map((s) => ({
    description: s.description,
    value: w(typeof s.value == "function" ? s.value() : s.value)
  })) : Object.values(t).filter((s) => s !== void 0).map((s) => ({
    description: s.description,
    value: w(typeof s.value == "function" ? s.value() : s.value)
  }));
}
function S(t) {
  const s = t.split(`
`), o = s.filter((e) => e.trim().length > 0);
  if (o.length === 0)
    return t;
  const i = o.map((e) => {
    const n = e.match(/^(\s*)/);
    return n ? n[1].length : 0;
  }), r = Math.min(...i);
  return s.map((e) => e.trim().length === 0 ? e : e.slice(r)).join(`
`);
}
export {
  A as CopilotSession,
  M as prepareContextForTransport,
  C as prepareInstructionsForTransport,
  I as prepareToolsForTransport,
  w as stringifyForCopilot,
  S as undent,
  v as updatedStatus
};
